export const normalizeLicensePlate = (input: string) => {
	return input
		.toUpperCase() // Convert to uppercase
		.replace(/[^A-Z0-9]/g, '') // Remove all non-alphanumeric characters
		.slice(0, 8); // Enforce max length of 8 characters;
};
